const bvb = [
  {
    id: 1,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 26/27 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2026",
      "borussia",
      "dortmund",
      "2026 borussia dortmund",
      "2026",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bvb/26-27-01/uni0.jpg",
      "/images/europa/bvb/26-27-01/uni1.jpg",
      "/images/europa/bvb/26-27-01/uni2.jpg",
      "/images/europa/bvb/26-27-01/uni3.jpg",
      "/images/europa/bvb/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2025",
      "borussia",
      "dortmund",
      "2025 borussia dortmund",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bvb/25-26-01/uni0.jpg",
      "/images/europa/bvb/25-26-01/uni1.jpg",
      "/images/europa/bvb/25-26-01/uni2.jpg",
      "/images/europa/bvb/25-26-01/uni3.jpg",
      "/images/europa/bvb/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2025",
      "borussia",
      "dortmund",
      "2025 borussia dortmund",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/25-26-01-es/uni0.jpg",
      "/images/europa/bvb/25-26-01-es/uni1.jpg",
      "/images/europa/bvb/25-26-01-es/uni2.jpg",
      "/images/europa/bvb/25-26-01-es/uni3.jpg",
      "/images/europa/bvb/25-26-01-es/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2025",
      "borussia",
      "dortmund",
      "2025 borussia dortmund",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/25-26-00-es2/uni0.jpg",
      "/images/europa/bvb/25-26-00-es2/uni1.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2025",
      "borussia",
      "dortmund",
      "2025 borussia dortmund",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/25-26-00-es/uni0.jpg",
      "/images/europa/bvb/25-26-00-es/uni1.jpg",
      "/images/europa/bvb/25-26-00-es/uni2.jpg",
      "/images/europa/bvb/25-26-00-es/uni3.jpg",
      "/images/europa/bvb/25-26-00-es/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2024",
      "borussia",
      "dortmund",
      "2024 borussia dortmund",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bvb/24-25-01/uni0.jpg",
      "/images/europa/bvb/24-25-01/uni1.jpg",
      "/images/europa/bvb/24-25-01/uni2.jpg",
      "/images/europa/bvb/24-25-01/uni3.jpg",
      "/images/europa/bvb/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2024",
      "borussia",
      "dortmund",
      "2024 borussia dortmund",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bvb/24-25-02/uni0.jpg",
      "/images/europa/bvb/24-25-02/uni1.jpg",
      "/images/europa/bvb/24-25-02/uni2.jpg",
      "/images/europa/bvb/24-25-02/uni3.jpg",
      "/images/europa/bvb/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2024",
      "borussia",
      "dortmund",
      "2024 borussia dortmund",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bvb/24-25-03/uni0.jpg",
      "/images/europa/bvb/24-25-03/uni1.jpg",
      "/images/europa/bvb/24-25-03/uni2.jpg",
      "/images/europa/bvb/24-25-03/uni3.jpg",
      "/images/europa/bvb/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 24/25 - Uniforme de Goleiro (Roxa)",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2024",
      "borussia",
      "dortmund",
      "2024 borussia dortmund",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bvb/24-25-05-gr/uni0.jpg",
      "/images/europa/bvb/24-25-05-gr/uni1.jpg",
      "/images/europa/bvb/24-25-05-gr/uni2.jpg",
      "/images/europa/bvb/24-25-05-gr/uni3.jpg",
      "/images/europa/bvb/24-25-05-gr/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 24/25 - Uniforme de Goleiro (Verde)",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2024",
      "borussia",
      "dortmund",
      "2024 borussia dortmund",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bvb/24-25-05-gv/uni0.jpg",
      "/images/europa/bvb/24-25-05-gv/uni1.jpg",
      "/images/europa/bvb/24-25-05-gv/uni2.jpg",
      "/images/europa/bvb/24-25-05-gv/uni3.jpg",
      "/images/europa/bvb/24-25-05-gv/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 23/24 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2023",
      "borussia",
      "dortmund",
      "2023 borussia dortmund",
      "2023",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bvb/23-24-01/uni0.jpg",
      "/images/europa/bvb/23-24-01/uni1.jpg",
      "/images/europa/bvb/23-24-01/uni2.jpg",
      "/images/europa/bvb/23-24-01/uni3.jpg",
      "/images/europa/bvb/23-24-01/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 23/24 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2023",
      "borussia",
      "dortmund",
      "2023 borussia dortmund",
      "2023",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/22-23-00-es/uni0.jpg",
      "/images/europa/bvb/22-23-00-es/uni1.jpg",
      "/images/europa/bvb/22-23-00-es/uni2.jpg",
      "/images/europa/bvb/22-23-00-es/uni3.jpg",
      "/images/europa/bvb/22-23-00-es/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 23/24 - Uniforme Edição Especial Manga Longa",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2023",
      "borussia",
      "dortmund",
      "2023 borussia dortmund",
      "2023",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/23-24-00-es-mc/uni0.jpg",
      "/images/europa/bvb/23-24-00-es-mc/uni1.jpg",
      "/images/europa/bvb/23-24-00-es-mc/uni2.jpg",
      "/images/europa/bvb/23-24-00-es-mc/uni3.jpg",
      "/images/europa/bvb/23-24-00-es-mc/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 12/13 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 2023",
      "borussia",
      "dortmund",
      "2023 borussia dortmund",
      "2023",
      "retro borussia dortmund",
      "retro",
      "borussia dortmund retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/12-13-01-rt/uni0.png",
      "/images/europa/bvb/12-13-01-rt/uni1.png",
      "/images/europa/bvb/12-13-01-rt/uni2.png",
      "/images/europa/bvb/12-13-01-rt/uni3.png",
      "/images/europa/bvb/12-13-01-rt/uni4.png",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 98/99 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 1998",
      "borussia",
      "dortmund",
      "1998 borussia dortmund",
      "1998",
      "retro borussia dortmund",
      "retro",
      "borussia dortmund retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/98-99-02-rt/uni0.jpg",
      "/images/europa/bvb/98-99-02-rt/uni1.jpg",
      "/images/europa/bvb/98-99-02-rt/uni2.jpg",
      "/images/europa/bvb/98-99-02-rt/uni3.jpg",
      "/images/europa/bvb/98-99-02-rt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 96/97 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 1996",
      "borussia",
      "dortmund",
      "1996 borussia dortmund",
      "1996",
      "retro borussia dortmund",
      "retro",
      "borussia dortmund retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/96-97-01-rt/uni0.jpg",
      "/images/europa/bvb/96-97-01-rt/uni1.jpg",
      "/images/europa/bvb/96-97-01-rt/uni2.jpg",
      "/images/europa/bvb/96-97-01-rt/uni3.jpg",
      "/images/europa/bvb/96-97-01-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 96/97 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 1996",
      "borussia",
      "dortmund",
      "1996 borussia dortmund",
      "1996",
      "retro borussia dortmund",
      "retro",
      "borussia dortmund retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/96-97-02-rt/uni0.jpg",
      "/images/europa/bvb/96-97-02-rt/uni1.jpg",
      "/images/europa/bvb/96-97-02-rt/uni2.jpg",
      "/images/europa/bvb/96-97-02-rt/uni3.jpg",
      "/images/europa/bvb/96-97-02-rt/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 96/97 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 1996",
      "borussia",
      "dortmund",
      "1996 borussia dortmund",
      "1996",
      "retro borussia dortmund",
      "retro",
      "borussia dortmund retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/96-97-00-rt/uni0.jpg",
      "/images/europa/bvb/96-97-00-rt/uni1.jpg",
      "/images/europa/bvb/96-97-00-rt/uni2.jpg",
      "/images/europa/bvb/96-97-00-rt/uni3.jpg",
      "/images/europa/bvb/96-97-00-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 95/96 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 1996",
      "borussia",
      "dortmund",
      "1996 borussia dortmund",
      "1996",
      "retro borussia dortmund",
      "retro",
      "borussia dortmund retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/95-96-02/uni0.jpg",
      "/images/europa/bvb/95-96-02/uni1.jpg",
      "/images/europa/bvb/95-96-02/uni2.jpg",
      "/images/europa/bvb/95-96-02/uni3.jpg",
      "/images/europa/bvb/95-96-02/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "bundesliga",
    time: "borussia-dortmund",
    nome: "Borussia Dortmund 94/95 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "borussia dortmund",
      "borussia dortmund 1994",
      "borussia",
      "dortmund",
      "1994 borussia dortmund",
      "1994",
      "retro borussia dortmund",
      "retro",
      "borussia dortmund retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bvb/94-95-01-rt/uni0.jpg",
      "/images/europa/bvb/94-95-01-rt/uni1.jpg",
      "/images/europa/bvb/94-95-01-rt/uni2.jpg",
      "/images/europa/bvb/94-95-01-rt/uni3.jpg",
      "/images/europa/bvb/94-95-01-rt/uni4.jpg",
    ],
  },
];

export default bvb;
